module.exports = __webpack_public_path__ + "img/01.c7e44dca.png";